// Wrappers around localStorage that swallow exceptions thrown in
// private mode or when storage quota is exceeded. Callers fall back to
// in-memory state held by their component, so missing persistence is
// acceptable but a thrown exception would crash the render.

export function safeRead(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeWrite(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    /* private mode / quota exceeded — fail silently */
  }
}
